<template>
  <roe-error-message :field="design.profit_sharing_allocation_method">
    <v-select
      name="profit_sharing_allocation_method"
      v-model.number="design.$model.profit_sharing_allocation_method"
      :options="[
        { code: 0, label: 'None' },
        { code: 1, label: 'Percent of Pay' },
        { code: 2, label: 'Flat dollar' },
        { code: 3, label: 'Integrated with social security' },
        { code: 4, label: 'Government contract (prevailing wage)' },
        { code: 5, label: 'Age weighted formula' },
        {
          code: 6,
          label: 'New comparability formula - individual groups'
        },
        {
          code: 7,
          label: 'New comparability formula - defined allocation groups'
        }
      ]"
      :reduce="label => label.code"
      @input="resetFormulaFields(), setEOY()"
      required
    >
    </v-select>
  </roe-error-message>
</template>

<script>
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
export default {
  name: "RoeEmployerOtherFormulaSelect",
  components: { RoeErrorMessage },
  props: {
    design: Object
  },
  methods: {
    resetFormulaFields() {
      [
        "profit_sharing_amount_percent",
        "employer_other_dollar_maximum",
        "employer_other_dollar_maximum_amount",
        "employer_other_flat_dollar_amount",
        "employer_other_integrated_base_percent_below",
        "employer_other_integrated_base_percent_above",
        "employer_other_integrated_wage_base"
      ].forEach(attr => {
        if (!this.attrToNotReset().includes(attr))
          this.design.$model[attr] = null;
      });
    },
    attrToNotReset() {
      switch (this.design.$model.profit_sharing_allocation_method) {
        case 1:
          return [
            "profit_sharing_amount_percent",
            "employer_other_dollar_maximum",
            "employer_other_dollar_maximum_amount"
          ];
        case 2:
          return ["employer_other_flat_dollar_amount"];
        case 3:
          return [
            "employer_other_integrated_base_percent_below",
            "employer_other_integrated_base_percent_above",
            "employer_other_integrated_wage_base"
          ];
        default:
          return [];
      }
    },
    setEOY() {
      if (this.design.$model.profit_sharing_allocation_method === 3) {
        this.design.$model.employer_other_funding_frequency = "eoy";
      }
    }
  }
};
</script>
